import { styled, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";

import { Mortgage } from "../../model/MortgageExtensionModel";

export const SummaryHeaderLabel = styled(Typography)(({ theme }) => ({
    color: "#333333",
    fontSize: "21px",
    fontWeight: "500",
    letterSpacing: 0,
    lineHeight: "27px",
    marginBottom: "16px",
}));

const AddressInfo = (props: { selectedMortgage: Mortgage }) => {
    const { selectedMortgage } = props;

    return (
        <Box display={"flex"} alignItems="center" justifyContent="flex-start" data-cy={"address-info"}>
            <SummaryHeaderLabel>{`${selectedMortgage.location} | ${selectedMortgage.ownerName}`}</SummaryHeaderLabel>
        </Box>
    );
};

export default AddressInfo;
